import { DefaultPageTemplate } from '@@/common/components/default-page-template';
import { Responses404 } from '@consta/uikit/Responses404';
import { Link } from 'react-router-dom';
import { UiButton } from '@@/ui/components/ui-button';

import styles from './index.module.sass';

export function NotFoundPage() {
  return (
    <DefaultPageTemplate className={styles.root}>
      <Responses404
        actions={
          <Link to="/">
            <UiButton label="На главную" />
          </Link>
        }
      />
    </DefaultPageTemplate>
  );
}
